import axios from "axios";
import { createProxyUrl, getAemContentUrl, getDealerOrInternalPersona, useLocale } from "../../utils";
import { useApiClient } from "./index";

const useAem = (path: string, pageKey: string, aemBaseUrl: string) => {
  const { country, locale } = useLocale();

  let contentUrl = getAemContentUrl(aemBaseUrl, path, country, locale, getDealerOrInternalPersona());
  contentUrl = createProxyUrl(contentUrl);

  const fetcher = () =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    axios.get(contentUrl, { withCredentials: true }).then((res) => res.data);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data, error, isLoading } = useApiClient(path, fetcher, pageKey);

  return {
    fetcher,
    aemContent: data,
    isLoading,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    isError: error
  };
};

export default useAem;
